export default __webpack_public_path__ + "static/media/Hero.2627f029.jpg";